import type {Media} from '../types';

export const sortMedia = (a: Media, b: Media): number => {
  const order = ['CONTENT', 'COVER', 'ATTACHMENT', '', undefined];

  return order.indexOf(a.subType) > order.indexOf(b.subType) ? 1 : -1;
};
